// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.container-vlc-camera {
  background: black;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/components/supervision components/vlc-camera/vlc-camera.component.scss","webpack://./src/components/supervision%20components/vlc-camera/vlc-camera.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,cAAA;ACCJ","sourcesContent":["img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.container-vlc-camera{\n    background: black;\n    margin:  0 auto;\n}","img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.container-vlc-camera {\n  background: black;\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
